<template>
  <v-row class="py-1 px-5 grey lighten-4 fill-height">
    <v-col cols="12">
      <v-row>
        <v-col cols="12" PagingC>
          <Paging :resourceSettings="resourceSettings" :resource="resource" @loadResource="loadResource"
            @pageByNumber="pageByNumber" />
        </v-col>

        <v-col cols="12" class="py-0">
          <v-row justify-content="center">
            <v-col cols="auto" class="mx-auto">
              <v-btn
                color="primary"
                @click.prevent="()=>{newResource = {}; dialog = true;}"
              >New</v-btn>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" Details>
          <v-card class="px-3" :loading="loading">
            <v-card-text>
              <v-row align="center" v-for="setting in resource.data" :key="`key-${setting.id}`" :class="`${arabic ? 'arFont' : 'enFont'}`" class="mb-2" style="border-radius: 6px; border: 1px solid #ececec;">
                <v-col cols="6" md="2">
                  <span style="font-size: 12px; font-weight: bold">Program</span>
                  <br>
                  <v-chip small color="brown" dark>
                    {{ setting.program_name.slug }}
                  </v-chip>
                </v-col>
                <v-col cols="6" md="2">
                  <span style="font-size: 12px; font-weight: bold">Country</span>
                  <br>
                  <span style="text-transform: capitalize;">{{ setting.country_name.slug }}</span>
                </v-col>
                <v-col cols="6" md="2" v-if="setting.days">
                  <span style="font-size: 12px; font-weight: bold">Days</span>
                  <br>
                  <span style="text-transform: capitalize;">{{ setting.days ? setting.days.replace("|", ", ") : "" }}</span>
                </v-col>
                <v-col cols="6" md="2">
                  <span style="font-size: 12px; font-weight: bold">From</span>
                  <br>
                  <v-chip color="blue" small dark>{{ setting.date_from }} {{ setting.from }}</v-chip>
                </v-col>
                <v-col cols="6" md="2">
                  <span style="font-size: 12px; font-weight: bold">To</span>
                  <br>
                  <v-chip color="blue" small dark>{{ setting.date_to }} {{ setting.to }}</v-chip>
                </v-col>
                <v-col cols="6" md="2">
                  <div>
                    <v-btn class="mr-2" x-small color="primary" @click.prevent="() => editResource(setting)">
                      <v-icon small>create</v-icon>
                      <span>Edit</span>
                    </v-btn>
                    <v-btn x-small color="error" @click.prevent="() => triggerDelete(setting)">
                      <v-icon small>delete</v-icon>
                      <span>Delete</span>
                    </v-btn>
                  </div>
                </v-col>

              </v-row>
              <!-- {{resource.data}} -->
            </v-card-text>
          </v-card>
        </v-col>

        <multiDialog :dialog="dialog" :loading="loading" :resourceSettings="resourceSettings" :deleting="deleting"
          :resourceKeys="resourceKeys" :newResource="newResource"
          @closeDialog="() => { dialog = false; newResource = {}; }" @deleteResource="deleteResource"
          @updateResource="updateResource" @postResource="postResource" />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Search from '@/components/Search'
import Paging from '@/components/Paging'
import multiDialog from '@/components/multiDialog'
import { format } from 'timeago.js';

export default {
  components: { Search, Paging, multiDialog },
  data() {
    return {
      page: 1,
      loading: false,
      print_dialog: false,
      dialog: false,
      resource: [],
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys: [
        { name: 'country_id', label:'country', type:'select', items:'countries', source:'db', data:[], required:true },
        { name: 'program_id', label:'program', type:'select', items:'programs', source:'db', data:[], required:true },
        { name: 'date_from', label: 'from_date', type: 'date', fetched: 'from', required: true },
        { name: 'date_to', label: 'to_date', type: 'date', fetched: 'to', required: true },
        { name: 'days', label:'days', type:'select', items:'days', data:['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'], source:'local', fetched:'days',  required: true, multiple:true },
        { name: 'from', label: 'from', type: 'time', fetched: 'from', required: true },
        { name: 'to', label: 'to', type: 'time', fetched: 'to', required: true },
        { name: 'number', label: 'number', type: 'number', fetched: 'number', required: true },
        { name: 'duration', label: 'duration', type: 'number', fetched: 'duration', required: true },
      ],
      resourceSettings: {
        resourceName: null,
        search: false,
        create: true,
        pagination: true,
      },
      newResource: {},
      editing: false,
      deleting: false,
    }
  },

  methods: {
    triggerDelete(resource) {
      this.newResource = {...resource}
      this.newResource.days = this.newResource.days.split("|")
      this.deleting = true
      this.dialog = true
    },
    editResource(resource) {
      this.newResource = {...resource}
      this.newResource.days = this.newResource.days.split("|")
      this.dialog = true
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x => typeof x == 'string')
      let a = false
      v.forEach(x => {
        if (x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if (itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    async filterLeads() {
      await this.loadResource()
    },
    clipboardSuccessHandler() {
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler() {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    editLead(r) {
      this.dialog = true
      this.editing = true
      this.newResource = r
    },
    async loadItems() {
      return new Promise(async (res, rej) => {
        let iks = ['countries', 'programs'];

        for (let i = 0; i < iks.length; i++) {
          const f = iks[i];
          let t = this.resource[f]
          console.log(t)
          if (!t.error)
            t.forEach(x => this.$store.state.i18n.en[x.slug] = x.en)
          t.forEach(x => this.$store.state.i18n.ar[x.slug] = x.ar)
          t.forEach(x => this.$store.state.i18n.fr[x.slug] = x.fr)
          this[f] = t
        }

        let ks = this.resourceKeys.filter(x => x.type == 'select' && x.source == 'db');
        (async x => {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            console.log(f.items)
            f.data = this.resource[f.items].map(x => {
              return {
                ...x,
                text: x.name ? x.name : x.en ? x.en : 'unknown',
                [`${f.name}_id`]: x.id
              }
            })
          }
          res(true)
        })()
      })
    },
    superA() {
      return this.$store.state.user && this.$store.state.user.role == 'superadmin'
    },
    getFormat(d) {
      return format(d)
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
        !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x => { })
    },
    async loadResource() {
      return new Promise(async (res, rej) => {
        this.loading = true
        this.resource = await this.$store.dispatch('getResource', { resource: '/evaluation-appointment-settings', page: `?page=${this.page}` })
        console.log(this.resource);
        this.loading = false
        await this.loadItems()
        res(true)
      })
    },
    async pageByNumber(n) {
      return new Promise(async (res, rej) => {
        this.loading = true
        this.page = n
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', { resource: '/evaluation-appointment-settings', page: `?page=${n}`})
        } else {
          this.resource = await this.$store.dispatch('searchResource', { resource: '/evaluation-appointment-settings' + `/search?page=${n}`, value: this.search })
        }
        this.loading = false
        res(true)
      })
    },
    async searchResource(search) {
      return new Promise(async (res, rej) => {
        this.search = search
        this.loading = true
        this.resource = await this.$store.dispatch('searchResource', { resource: '/evaluation-appointment-settings' + '/search', value: this.search })
        this.loading = false
        res(true)
      })
    },
    async updateResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true
        console.log(r)
        await this.$store.dispatch('putResource', { resource: '/evaluation-appointment-settings' + `/${r.id}`, value: r })
        this.dialog = false
        this.editing = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
        res(true)
      })
    },
    async deleteResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true
        await this.$store.dispatch('deleteResource', { resource: '/evaluation-appointment-settings' + `/${r.id}` })
        this.dialog = false
        this.deleting = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}
        res(true)
      })
    },
    async postResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true
        const data = await this.$store.dispatch('postResource', { resource: '/evaluation-appointment-settings' + `${r.id ? '/' + r.id : ''}`, value: r })
        this.dialog = false
        this.loading = false
        await this.loadResource()
        this.newResource = {}

        this.print_dialog = true
        this.printResource = data.candidate
        res(true)
      })
    },
    setResourceName() {
      this.resourceSettings.resourceName = '/evaluation-appointment-settings'.replace('/', '')
    }
  },
  watch: {
  },
  computed: {
    api() {
      return this.$store.state.settings.apiBase
    },
    users() {
      return this.resource.users
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      console.log(sa)
      return this.$store.state.users.filter(x => {
        if (!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site() {
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin() {
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language() {
      return this.$store.state.language
    },
    globalLoading() {
      return this.$store.state.globalLoading
    },
    user() {
      return this.$store.state.user
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true
    },
    routeTitle() {
      let main = this.$store.state.menu.filter(x => x.path == '/evaluation-appointment-settings')
      let sub = [].concat(...this.$store.state.menu.map(x => x.subs)).filter(x => x).filter(x => x.path == '/evaluation-appointment-settings')
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles() {
      return this.$store.state.userRoles
    },
    notifications() {
      return this.$store.state.notifications.sort((a, b) => b.timestamp - a.timestamp)
    },
  },
  async created() {
    this.setResourceName()
    await this.loadResource()
    await this.loadItems()
  },

}
</script>

<style>
.adminSwitch .v-input {
  margin-top: 0 !important;
}

.adminSwitch .v-input__control {
  margin-bottom: 0 !important;
}

.adminSwitch .v-label {
  font-size: 12px !important;
}
</style>